import React from 'react';
import PropTypes from 'prop-types';

const Navbar = ({textLeft, textRight}) => (
    <div>
        <nav className="navbar navbar-default navbar-fixed-top">
            <span className="col-xs-7 navbar-text">
                <span className="navbar-text--left">{textLeft}</span>
            </span>
            <span className="col-xs-3 col-xs-offset-2">
                <span className="navbar-text">
                    <span className="navbar-text--right">{textRight}</span>
                </span>
            </span>
        </nav>
    </div>
);

Navbar.propTypes = {
    textLeft: PropTypes.string.isRequired,
    textRight: PropTypes.string.isRequired,
};

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar.js